/* eslint-disable max-len */
import * as falso from '@ngneat/falso';
import { AdminAssessment } from 'types/AdminAssessment';

import { createMockFolder } from './folders';
import { AssessmentStatus } from '../types/enums/AssessmentStatus';

falso.seed('adminassessment-mock');
const idFactory = falso.incrementalNumber();

const createMockAdminAssessmentData = (
  { leader, folder, product, status }: { leader?: Leader, folder?: Folder, product?: string[], status?: AssessmentStatus } = {},
): AdminAssessment => ({
  entitlementId: idFactory().toString(),
  product: product ? falso.rand(product) : falso.rand(['lpi-360', 'lpi-360-plus', 'lpi-self', 'lpi-self-empowered', 'pre-work', 'lpi-student-360', 'lpi-student-self']),
  leaderFirstName: leader?.firstName || falso.randFirstName(),
  leaderLastName: leader?.lastName || falso.randLastName(),
  leaderEmail: leader?.email || falso.randEmail(),
  leaderUserId: leader?.userId || idFactory().toString(),
  createdAt: '2023-03-23',
  completedAt: '2023-03-23',
  status: status ? status : falso.rand([
    AssessmentStatus.ACCEPTED,
    AssessmentStatus.COMPLETED,
    AssessmentStatus.INVITATION_SENT,
    AssessmentStatus.IN_PROGRESS,
  ]),
  observers: {
    total: falso.randNumber({ min: 0, max: 10 }),
    totalCompleted: falso.randNumber({ min: 0, max: 10 }),
  },
  folder: folder ? folder : createMockFolder(),
  surveyComplete: falso.randBoolean() ? '2023-03-23' : undefined,
  reassessmentDate: falso.randBoolean() ? '2023-03-23' : undefined,
  managerCompleted: falso.randBoolean(),
  totalObservers: falso.randNumber({ min: 0, max: 10 }),
  totalObserversCompleted: falso.randNumber({ min: 0, max: 10 }),
});

export const createMockAdminAssessment = (
  { leader }: { leader?: Leader } = {},
): AdminAssessment => createMockAdminAssessmentData({ leader });

export const createMockAdminAssessments = (
  { length = falso.randNumber({ min: 0, max: 100 }), leader, folder, product, status }: { length?: number; leader?: Leader, folder?: Folder, product?: string[], status?: AssessmentStatus } = {},
): AdminAssessment[] => (
  Array.from({ length }, () => createMockAdminAssessmentData({ leader, folder, product, status }))
);
